import { apiClient, ensureCsrfCookie } from '../../api/client';

/**
 * Единственная дверь к полному номеру (`zhur1`): сервер СНАЧАЛА пишет ход в
 * журнал ходьбы (show → reveal, call → click) и только потом отдаёт номер.
 * Все места панели, которым нужен полный номер (маска, мини-карточка CRM,
 * перезвон), обязаны проходить здесь — второй дороги нет по конструкции.
 */
export type DverSushchnost =
  | 'customers'
  | 'customer_channels'
  | 'form_submissions'
  | 'form_drafts'
  | 'tel_calls'
  | 'tel_call_attempts'
  | 'tel_inbound_waiting'
  | 'tel_call_tasks';

/** Ключ одного нажатия: с ним повтор того же запроса не станет вторым раскрытием. */
function novyyKlyuch(): string | undefined {
  try {
    return crypto.randomUUID();
  } catch {
    return undefined;
  }
}

/**
 * Открыть номер: показать (`show`), скопировать кнопкой (`copy`) или позвонить (`call`).
 *
 * ⛔ ОДНО НАЖАТИЕ — ОДИН КЛЮЧ (`s704`). Сеть моргнула — запрос повторяется С ТЕМ ЖЕ
 * ключом, и сервер отдаёт номер по уже записанной строке, а не пишет вторую. Новое
 * нажатие — новый ключ и новое раскрытие. Иначе владелец видел бы «два раскрытия»
 * там, где человек нажал один раз, и считал бы не людей, а обрывы связи.
 */
export async function otkrytNomer(
  entityType: DverSushchnost,
  entityId: number,
  purpose: 'show' | 'call' | 'copy',
): Promise<string | null> {
  await ensureCsrfCookie();

  const telo = {
    entity_type: entityType,
    entity_id: entityId,
    purpose,
    route: window.location.pathname,
    request_key: novyyKlyuch(),
  };

  let otvet;
  try {
    otvet = await apiClient.post<{ phone: string }>('/browse/phone', telo);
  } catch (e) {
    // Повтор — только когда ответа не было вовсе (обрыв). Отказ и «номера нет» не повторяются.
    const bezOtveta = !(e as { response?: unknown }).response;
    if (!bezOtveta || !telo.request_key) throw e;
    otvet = await apiClient.post<{ phone: string }>('/browse/phone', telo);
  }

  const nomer = otvet.data.phone ?? null;

  // Номер дошёл до панели и будет нарисован — сообщаем серверу. Это сообщение
  // панели, а не доказательство, что человек номер прочитал.
  if (nomer && purpose !== 'call' && telo.request_key) {
    void apiClient.post('/browse/phone/shown', { request_key: telo.request_key }).catch(() => undefined);
  }

  return nomer;
}
